import { useQuery } from "@tanstack/react-query";
import { api } from "utils/hostname";
import { ExpSettings } from "types/ExpSettings";
import url from "../url";

export const useGetExpSettingCurrency = () => {
  const { data } = useQuery({
    queryKey: ["exp-setting"],
    queryFn: () =>
      api(true, true).get<{ data: ExpSettings }>(
        url.config.api.loyalty.expSetting,
      ),
    staleTime: Infinity,
  });

  return {
    exp: data?.data?.data,
  };
};
